function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLista2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 130,
    viewBox: "0 -960 960 960",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(83,170,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M581-142h236v-26q-21-28-52-44t-66-16q-36 0-67 16t-51 44v26Zm118-118q20 0 34-14t14-34q0-20-14-34t-34-14q-21 0-34.5 14T651-308q0 20 13.5 34t34.5 14ZM480-480Zm-3-85q-35 0-60 24.5T392-480q0 27 13.5 47t35.5 31q1-6 3-11.5t3-10.5q-16-7-24.5-22.5T414-480q0-26 18.5-44.5T477-543q18 0 32.5 8.5T533-511q5-2 11-4t12-2h-3q-10-22-30.5-35T477-565Zm-56 433-15-111q-23-7-51-22.5T308-299l-102 46-59-105 90-67q-2-13-3.5-27t-1.5-27q0-12 1.5-26t3.5-30l-90-68 59-102 101 44q22-18 48-33t50-22l16-112h118l15 112q27 10 50 23t45 32l106-44 58 102-99 75q0 3 .5 4.5t1.5 3.5h-19l-2-10-2-10 92-69-40-69-105 44q-18-20-49-39t-57-22l-13-111h-82l-12 110q-32 6-57.5 20.5T318-635l-103-43-40 69 90 66q-5 14-7 30t-2 34q0 16 2 31t6 30l-89 67 40 69 102-43q24 25 55.5 40.5T439-261v129h-18Zm166 32q-21 0-34.5-14T539-148v-224q0-20 13.5-34t34.5-14h224q20 0 34 14t14 34v224q0 20-14 34t-34 14H587Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLista2);
export default __webpack_public_path__ + "static/media/lista2.0222a5bf414c4a7dbcd2880486d91d7b.svg";
export { ForwardRef as ReactComponent };